module.exports =  {
  TITLE: {
    default: 'Sök hotell | Tiotusentals hotell i Asien online för bokning',
    detail: '|Hotellbokning',
  },
  hotel: {
    // Hotellsökningen har ändrats för att inkludera översättningar på engelska
    ROOMS: 'Rum',
    GUESTS: 'Gäster',
    CHECK_IN_NUM: 'Gäster',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Vuxen',
    SUFFIX_ADULTS: 'Vuxna',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Barn',
    SUFFIX_CHILDREN: 'Barn',
    CHILD_AGE: 'Barnets ålder',
    NO_MATCH_TIPS: 'Rumstypen nedan matchar inte antalet rum och gäster du valt.',

    Book_Hotel: 'Boka hotell',
    Select_your_destination: 'Välj din destination',
    Please_enter_your_destination: 'Ange din destination/hotell',
    Booked_up: 'Bokat',
    Hotel_description: 'Hotellbeskrivning',
    Check_in_date: 'Incheckningsdatum',
    Check_out_date: 'Utcheckningsdatum',
    Sold_out: 'Slut på platser',
    Non_refundable: 'Ej återbetalningsbar',
    reserve: 'Boka',
    Pay_Online: 'Betala online',
    Only_rooms_left_before: 'Endast ',
    Only_rooms_left_after: ' rum kvar',
    Cancellation_Policy: 'Avbokningspolicy',
    See_all_prices_before: 'Se alla ',
    See_all_prices_after: 'priser',
    Estimated_time_of_arrival: 'Beräknad ankomsttid',
    make_your_schedule_well_planned: 'Tiden är för lokal tidszon, vänligen planera din tid väl och kom i tid.',
    Hotel_Not_Found: 'Hotell ej hittat',
    Please_change_your_search: 'Vänligen ändra din sökning',
    Submit_an_application: 'Skicka in en ansökan',
    Hotel_Confirmation: 'Hotellbekräftelse',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-nätters vistelse',
    Hotel_Booking_Number: 'Hotellbokningsnummer',
    Online_Payment: 'Online-betalning',
    The_guest_Room_before: 'Gäst[Rum',
    The_guest_Room_after: ']',
    Contact_number: 'Kontaktnummer',
    Bring_all_valid_IDs: 'Vänligen ta med alla giltiga ID-handlingar för alla gäster vid incheckningen.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hittade hotell',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hotell presenterade (',
    Hotels_Presented_after: ' totalt)',
    Please_change_the_dates: 'Rummet är inte tillgängligt under dina datum, vänligen ändra datumen.',
    Login: 'Logga in på appen för att boka hotell',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Nätter totalt',
    Location: 'Plats',
    Pictures: 'Bilder',
    Description: 'Beskrivning',
    Policy: 'Policy',
    Check_in_and_check_out_time: 'In- och utcheckningstid',
    Check_in_and_Check_out_before: 'Incheckning: efter ',
    Check_in_and_Check_out_center: 'Utcheckning: före ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Incheckning',
    Check_out_time: 'Utcheckning',
    Facility_Service: 'Faciliteter & Service',
    Payment_methods: 'Betalningsmetoder godkända av hotellet',
    Hotel_Address: 'Hotelladress',
    Pay_online: 'Betala online',
    Pay_offline: 'Betala offline',
    Night_stay_before: '',
    Night_stay_after: '-nätters vistelse,',
    Rooms_total_before: 'Antal rum',
    Rooms_total_after: 'totalt',
    Guest_name_must_be_provided: 'Det fullständiga gästnamnet måste anges.',
    Please_fill_in_your_contact_number: 'Vänligen fyll i ditt kontaktnummer',
    Select_estimated_time_of_arrival: 'Välj beräknad ankomsttid',
    Number_of_Rooms: 'Antal rum',
    Maximum_guests_per_room_before: 'Högst ',
    Maximum_guests_per_room_after: ' gäster per rum',
    Many_Rooms: ' Rum',
    Service_Fee_Included: '(Inklusive skatt och serviceavgift)',
    Last_Name: 'Efternamn',
    First_Name: 'Förnamn ',
    Room: 'Rum',
    Additional_Tax: 'Ytterligare skatt',
    Please_inform_the_hotel: 'Om du skulle komma fram efter beräknad ankomsttid, vänligen informera hotellet i förväg.',
    Please_inform_the_hotel_first: 'Ankomst till hotellet efter beräknad ankomsttid utan att kontakta hotellet i förväg kommer att påverka tillgången på rum och middag. Informera hotellet först för att bekräfta tillgängligheten i sådana fall.',
    Booking_Cancellation: 'Avbokning av bokning',
    Reason_of_Cancellation: 'Avbokningsorsak',
    Incorrect_Information_Filled: 'Felaktig information ifylld',
    Itinerary_Changed: 'Reagerad resväg',
    Lower_price_on_other_APP: 'Lägre pris på annan app',
    Low_quality_hotel: 'Hotell av låg kvalitet',
    Book_at_a_lower_price: 'Boka till ett lägre pris i receptionen',
    Other: 'Annan',
    Please_write_your_reason: 'Vänligen skriv din anledning',
    After_cancellation_done: 'Efter avslutad avbokning kommer betalningen att returneras till den ursprungliga betalaren inom 3 arbetsdagar.',
    How_to_fill_in_the_guest_name: 'Hur fyller man i gästnamnet',
    It_should_be_exactly_the_same: 'Vänligen ange gästnamnet med engelska bokstäver för hotellreservation. Det ska vara exakt samma som certifikatet som presenteras när du checkar in.',
    How_to_fill_in_a_Chinese_name: 'Hur man fyller i ett kinesiskt namn:',
    How_to_fill_in_a_English_name: 'Hur man fyller i ett engelskt namn',
    For_example: 'Till exempel: Om ditt kinesiska namn är “韩梅梅”, är efternamnet "Han", förnamnet "Meimei".',
    No_specical_characters: 'Fyll inte i några siffror eller specialtecken. ',
    Name_rule_first: 'Efternamnet kommer först, förnamnet följer, och om det finns ett mellannamn följs det av ett mellanslag bakom de två namnen. ',
    Name_rule_second: 'Till exempel: Green / Jim Stephanie',
    Details: 'Detaljer',
    Pay_now: 'Betala nu',
    Hotel: 'Hotell',
    Check_in: 'Incheckning',
    Car: 'Bil',
    All_bookings: 'Alla bokningar',
    All: 'Alla',
    PROMPT: 'Observera',

      Search: 'Sök',
    COST_DESCRIPTION: 'Prisinformation',
    TOTAL: 'Totalt',
    SEE_ORDER_INFO_TO: 'Betala',
    KONW: 'Förstått',
    BOOKING_INFORMATION: 'Viktig information',
    Book_Now: 'Betala nu',
    MAP: 'Karta',
    CONTACT_INFORMATION: 'Kontaktinformation',
    LOADING: 'Laddar...',
    SORT_FILTER: 'Sortera/Filtrera',
    SCREENING: 'Filtrera',
    SEQUENCE: 'Sortera',
    PHONE_ASK: 'Ring oss',
    ABOVE: '',
    SUBMINT_ORDER: 'Skicka',
    OK: 'OK',
    Order_detail: 'Orderdetaljer',
    BOOKING_INFO: 'Bokningsinfo',
    PAYMENT_AMOUNT: 'Betalsumma',
    Order_time: 'Bokningstid',
    ORDER_NUMBERS: 'Bokningsnummer',
    PAY_TYPE: 'Betalningsmetod',
    BALANCE: 'Saldo',
    CURRENT_BALANCE_BEGIN: 'Saldo',
    OVERPLUS_BALANCE_BEGIN: 'Kvarvarande',
    OTHER_PAYMENT: 'Andra betalningsmetoder',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat-betalning',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Klicka på “Betala nu” innebär att du godkänner Baigolfs ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Serviceavtal》',
    PAYMENT_ORDER: 'Bokningsbetalning',
    Total_pay: 'Belopp att betala',
    PAY_SUCCESS: 'Betalning accepterad',
    CHECK_THE_ORDER: 'Kontrollera ordern',
    BACK_TO_INDEX: 'Tillbaka till Index',
    CANCEL: 'Avbryt',
    RECOMMED: 'Rekommendera',
    PRICE: 'Pris',
    HIGH: 'Hög',
    LOW: 'Låg',
    RESET: 'Återställ',
    SELECT_TIME: 'Välj datum',
    Hotel_guest: 'Gästen',
    Select: 'Vänligen välj',
    Emial_address: 'Ange e-postadress',
    Booking_explan: 'Bokningsinformation',
    VIEW_MORE: 'Visa mer',
    COLLAPSE: 'Dölj',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Incheckning',
    TOURISM_LEAVE_HOTEL: 'Utcheckning',
    arrive: 'Destination',
    Room_description: 'Rumsbeskrivning',
    Meals: 'Måltider',
    Room_Type: 'Rumstyp',
    BOOKING_EXPLANATION: 'Bokningsinformation',
    BOOKING_BUTTON: 'Boka',
    REMIND_SUBMIT_ORDER: 'Fortsätt',
    login_now: 'Hotellreservationer kräver inloggning, logga in nu?',
    the_real_scene: 'Bilder är endast för referens och föremål för verklig miljö.',
    Bed: 'Säng',
    Rooms: 'Rum',
    Room_rate: 'Rumspris',
    notified_by_SMS: 'Efter framgångsrik reservation kommer du att meddelas via SMS',
    email_notifications: 'Används för att ta emot e-postmeddelanden',
    Booking_deadline: 'Bokningsdeadline',
    Child: 'Barn',
    Additional_notes_about_payment: 'Ytterligare anteckningar om betalningen',
    Nights: 'Nätter',
    Minimum_nights_before: 'Minsta',
    Minimum_nights_after: 'nätter',
    Size: 'Storlek',
    Guests: 'Gäster',
    Room_rate_1: 'Rumspris',
    Tax_service_fee: 'Skatte/serviceavgift',
    Pay_now_1: 'Betala nu',
    Filter: 'Filtrera',
    Room_rate2: 'Rumspris',
    Show_on_map: 'Visa på karta',
    Detail: 'Detalj',
    Room_Detail: 'Detalj',

    TAXES_INCL: 'Inklusive skatter',
    SEARCH_EMPTY_TIP: 'Tyvärr finns det ingen tillgänglighet på ditt valda datum, du kan: söka efter alternativa datum eller hotell',
    severalNight: 'Nätter',
    immediateBooking: 'Boka nu',
    Refundable: 'Återbetalningsbar',
    MORE: 'Mer',
    adultsCompany: 'vuxna',
    ServiceTerms: 'Tjänster och villkor',
    roomPlan: 'Plan',
    guestRoom: 'Rum',
    searchAgain: 'Sök igen',
    roomNight: 'rum/natt',

   NAME_TXT: 'Namn',
  HOLDER_NAME: 'Kortinnehavarens namn',
  EXPIRATION_DATE: 'Utgångsdatum',
  FORMAT_TXT: 'Format',
  SECURITY_CODE: 'Säkerhetskod',
  MASTER_CARD_NAME: 'Mastercard',
  JCB_CARD_NAME: 'JCB',
  DIGITS_ON_BACK_OF_CARD: 'De 3 siffrorna på baksidan av kortet.',
  AMERICAN_EXPRESS_NAME: 'American Express',
  FOUR_CAR_NUM_TIPS: '4 siffror på framsidan av kortet',
  ENTER_COMPLETE_CARD_NUM: 'Ange ett komplett kortnummer.',
  PLEASE_ENTER_HOLDER_NAME: 'Ange kortinnehavarens namn',
  ENTER_SECURITY_CODE: 'Ange säkerhetskod',
  ENTER_EXPIRATION_DATE: 'Ange utgångsdatum',
  ROOM_DETAILS: 'Rumsdetaljer',
  CONDITION_CANCEL: 'Återbetalningsbar',
  CHOOSE_PAYMENT_METHOD: 'Betalning',
  ORDER_TOTAL_LUMP: 'Totalt belopp',
  CREDIT_CARD_NUM: 'Kontonummer för debet/kreditkort',
  MAINLAND_CARD_ONLY: 'Bankkort utfärdat utanför Fastlandskina endast.',
  SHUT_DOWN: 'Stäng',
  PROVIDER_FROM_CHINA_BANK: 'Betalningstjänst tillhandahållen av B.O.C',

  COUPON: 'Kupong',
  APPLY_A_COUPON: 'Använd en kupong',
  NO_USE: 'Gäller inte för detta erbjudande.',
  Discard: 'Kasta',
  REDEEM: 'Inlösen',
  EMPTY_COUPON: 'Ange kampanjkod',
  NOTICE_COUPON: 'Endast en kupong kan lösas in för varje bokning; kupongen löses in efter att bokningen har skickats in.',

  BREAKFAST_INCLUDE: 'frukost ingår',
  BREAKFAST_EXCLUDE: 'frukost ej ingår',
  DOUBLE_BED: 'dubbelsäng',
  TWIN_BED: 'tvåbäddsrum',
  FREE_CANCEL: 'gratis avbokning',
  MEALS: 'måltider',
  EVALUATION: 'Recension',
  FEATURED_REVIEWS: 'Utvalda recensioner',
  ALL_REVIEWS: 'Alla recensioner',
  OVERALL_EVALUATION: 'Total recension',
  ANONYMOUS: 'Anonym',
  EVAL_GENERAL_LIST_1: 'Dålig',
  EVAL_GENERAL_LIST_2: 'Rättvis',
  EVAL_GENERAL_LIST_3: 'Genomsnittlig',
  EVAL_GENERAL_LIST_4: 'Bra',
  EVAL_GENERAL_LIST_5: 'Utmärkt',
  MAX_IMAGES_WITH_NINE: 'Maximalt 9 bilder kan väljas.',
  GRADE_EVAL: 'Vänligen välj Totalbetyg',
  DISTANCE_FILTER: 'närhet nära-långt',
  EDIT_EVALUATION: 'ge kommentarer',
  GO_TO_EVAL: 'ge kommentarer',
  EVAL_POINTS_AWARD: 'Bra kommentarer kan vinna 1000 poäng, 1000 poäng = 10 RMB',
  NEARBY_LIKE_HOTEL: 'liknande hotell i närheten',
  DISTANCE_HOTEL: 'till hotellet',
  PLEASE_ENTER_COMMENT: 'kommentarer',
  AWARD_POINTS_TIPS: 'Bästa kommentarerna kan få 1000 poäng 1000 = 10 RMB',
  NO_SHOW_ANONYMOUS_AVATAR: 'Anonyma kommentarer kommer inte att visa din logotyp och ditt namn',
  LOCATION: 'plats',
  FACILITY: 'facilitet',
  SERVICE: 'tjänst',
  HEALTH: 'rent',
  LANGUAGE_SELECT: 'språk',
  LIMIT_COMMENT_TXT: 'Recension måste vara 5~2000 tecken',
  SHARE_MEDIA: 'Dela bilder och video',
  SETTLEMENT_FEEL: 'Kommentarer',
  SUBMIT_EVAL: 'Bekräfta',
  HOTEL_STR: 'Detaljer',
  EVAL_NUM_AFTER: 'recension',
},
header: {
  SKIING: 'Skidort',
  header_internal_call: 'Fastlandskina:',
  header_abroad_call: 'Internationellt:',
  header_app_download: 'Mobilapp',
  service_telephone: 'Kundtjänst',
  account_number: 'Konto',
  if_bg_user: 'Inte medlem i BaiGolf?',
  home: 'Hem',
  hotel: 'Hotell',
  Golf: 'Golf',
  PLAY_STAY: 'Bo & Spela',
  RENT_CAR_HOME: 'Bil',
  center_user: 'Medlemscenter',
  header_my_order: 'Mina bokningar',
  header_notmember_order: 'Gästbokningar',
  header_edit_password: 'Ändra lösenord',
  header_logout: 'Logga ut',
  header_login: 'Logga in',
  header_register: 'Registrera',
  header_point: 'Mina poäng',
  header_all_language: 'Alla språk',
  down_load_app: 'Skanna QR-koden för att ladda ner',
  login_discount_tip: 'Logga in för att tjäna bonus och njut av dina exklusiva förmåner'
},
footer: {
  footer_partner: 'Partner',
  footer_about_us: 'Om oss',
  footer_about_baigolf: 'Om BaiGolf.com',
  footer_privacy_policy: 'BaiGolf.com Integritetspolicy',
  footer_use_of_terms: 'BaiGolf.com Tjänstevillkor',
  footer_contact_us: 'Kontakta oss',
  footer_sitemap: 'Sitemap',
  footer_use_of_question: 'FAQ',
  footer_ios_system: 'iOS',
  footer_android_system: 'Android',
  footer_app_load: 'APP-nedladdning',
  footer_sina_weibo: 'Sina Weibo',
  footer_tencent_weibo: 'Tencent-mikroblogg',
  footer_share_to: 'Dela',
  copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Upphovsrätt ',
  copyright2: 'Yue ICP-registreringsnummer 14070002',
  news_center: 'Nyhetscenter',
  about_baigolf: 'Om BaiGolf',
  help: 'Hjälp',
  management_system: 'BG Golf Management System (BGMS)',
  wechat_official_account: 'WeChat officiellt konto',
  download_baiGolf_app: 'Ladda ner BaiGolf App',
  privacy_policy: 'Integritetspolicy',
  use_of_terms: 'Tjänstevillkor',
  footer_integral: 'Poängpolicy',
  footer_reserve: 'Bokningspolicy',
  footer_abroad_call: 'Internationellt',
  footer_internal_call: 'Fastlandskina'
  }
}



// WEBPACK FOOTER //
// ./src/lang/swedish.js